module.exports = __webpack_public_path__ + "static/media/emoji_clapping_hands.4231ca31.svg";